<div class="flex-col h-100">
    <ui-header-with-breadcrumbs [selectBreadcrumbs]="breadcrumbsSig()"></ui-header-with-breadcrumbs>

    <div class="ui-tab w-100 h-100 flex-col gap-16">
        <div class="h-100 min-h-0">
            <run-list-table [graphId]="graphIdSig()"
                            [orgId]="orgIdSig()">
            </run-list-table>
        </div>
    </div>
</div>